























import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import { format, parseISO } from "date-fns";

import ModalTabs from "../../DashboardLayoutComponents/ModalTabs.vue";
import FormField from "../../DashboardLayoutComponents/FormField.vue";
import EspressoAux from '../../../components/Espresso/EspressoAux.vue';

import ShiftCard from "@/layouts/DashboardLayoutComponents/ShiftCard.vue";

import shiftModel from "@/models/shift.model";

@Component({
	components: { ModalTabs, FormField, ShiftCard, VueperSlides, VueperSlide },
})
export default class DeleteModal extends Vue {
	tabs = [
		{ icon: "delete", name: "Deletar" },
	];

	@Prop() calendarDays: any[];

	dummyEntity: any = { deletionReason: "", auditNotes: "" };
	schema: any = [];

	constructor() {
		super();
	}

	private async mounted() {
		this.schema = await shiftModel.getDescription();
	}

	updateNotes(notes: string) {
		this.dummyEntity.auditNotes = notes;
	}

	private async deleteShifts() {
		if (!this.dummyEntity.deletionReason) {
			this.$toasted.error('Selecione uma justificativa para exclusão');
			return;
		}
		const selectedShifts: any[] = [].concat(...this.calendarDays.map(day => day.shifts));
		for (const shift of selectedShifts) {
			const shiftDate = format(parseISO(shift.startDateTime), "dd/MM/yyyy HH:mm");
			try {
				await shiftModel.delete(shift.id, `Justificativa: ${this.dummyEntity.deletionReason}\n${this.dummyEntity.auditNotes || ''}`);
				this.$toasted.success(`O plantão do dia ${shiftDate} foi deletado`, { duration: 5000 });
			} catch (error) {
				console.error(error);
				this.$toasted.error(`Não foi possível deletar o plantão do dia ${shiftDate}. Tente novamente.`)
				throw error;
			}
		}
		this.$emit("close");
	}
}
